module.exports = __webpack_public_path__ + "media/escudos/logo_essalud-7a343671.png";